import styled, { css } from 'styled-components';

export const CourseTabContent = styled.div`
  overflow-y: auto;
  height: 100%;
  color: ${({ theme }) => theme.freecode.color};
`;

export const CourseNameContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
`;

export const CourseName = styled.h5`
  margin-bottom: 0px;
  margin-right: auto;
  color: ${({ theme }) => theme.freecode.activeAreaColor};
`;

export const Icon = styled.i.attrs(({ icon }) => ({
  className: icon,
}))`
  padding-left: 50px;
  padding-right: 5px;
`;

export const ModuleContainer = styled.a`
  text-decoration: none;
  color: unset;
  cursor: pointer;
  padding: 5px;
  font-size: 14px;
  color: ${({ theme }) => theme.freecode.color};
  background: ${({ theme }) => theme.freecode.activeAreaBackgroundColor};

  :hover {
    text-decoration: none;
    color: ${({ theme }) => theme.freecode.dropdownItemActiveColor};
    background: ${({ theme }) => theme.freecode.headerBackground};
  }

  ${({ active }) =>
    active &&
    css`
      color: ${({ theme }) => theme.freecode.dropdownItemActiveColor};
      background: ${({ theme }) => theme.freecode.headerBackground};
    `}
`;

export const SyllabusContainer = styled.section`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const ExpandingListItemHeader = styled.span`
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 7px 10px 25px;
  color: ${({ theme }) => theme.freecode.color};
  background: ${({ theme }) => theme.freecode.activeAreaBackgroundColor};
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.freecode.dropdownItemActiveColor};
    background: ${({ theme }) => theme.freecode.headerBackground};
  }
`;

export const ExpandIcon = styled.i.attrs(({ icon }) => ({
  className: icon,
}))`
  color: ${({ theme }) => theme.freecode.color};
  margin-right: 10px;
`;
